/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    inverse: {
      description: 'Styles the step tracker for using on dark backgrounds.',
      type: 'variant',
      values: [ true ]
    },
    style: { type: 'variant', values: [ 'default', 'bar' ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'lg', 'xl' ] },
      tokens: { showStepLabel: true, showStepTrackerLabel: false }
    },
    {
      if: { inverse: true },
      tokens: {
        connectorColor: '#ffffff',
        connectorCompletedColor: '#ffffff',
        knobBackgroundColor: 'rgba(0, 0, 0, 0)',
        knobBorderColor: '#ffffff',
        knobCompletedBackgroundColor: 'rgba(0, 0, 0, 0)',
        knobCompletedBorderColor: '#ffffff',
        knobCurrentBackgroundColor: '#ffffff',
        knobCurrentBorderColor: '#ffffff',
        knobCurrentInnerColor: '#ffffff',
        labelColor: '#ffffff',
        labelCurrentColor: '#ffffff'
      }
    },
    { if: { style: 'bar' }, tokens: { barGap: 4, barHeight: 8 } }
  ],
  tokens: {
    barBackgroundColor: 'rgba(0, 0, 0, 0.1)',
    barCompletedBackgroundColor: '#613889',
    barCurrentBackgroundColor: '#613889',
    barGap: null,
    barHeight: null,
    completedIcon: null,
    completedIconColor: null,
    completedIconSize: null,
    connectorColor: '#676e73',
    connectorCompletedColor: '#7c53a5',
    connectorCompletedHeight: 3,
    connectorHeight: 1,
    connectorMinWidth: 16,
    containerPaddingBottom: null,
    containerPaddingLeft: null,
    containerPaddingRight: null,
    containerPaddingTop: null,
    knobBackgroundColor: 'rgba(0, 0, 0, 0)',
    knobBorderColor: '#676e73',
    knobBorderWidth: 1,
    knobCompletedBackgroundColor: 'rgba(0, 0, 0, 0)',
    knobCompletedBorderColor: '#7c53a5',
    knobCompletedPaddingLeft: 0,
    knobCompletedPaddingTop: 0,
    knobCurrentBackgroundColor: '#7c53a5',
    knobCurrentBorderColor: '#7c53a5',
    knobCurrentBorderWidth: 2,
    knobCurrentInnerColor: '#7c53a5',
    knobCurrentInnerSize: 8,
    knobCurrentPaddingLeft: null,
    knobCurrentPaddingTop: null,
    knobSize: 16,
    labelColor: '#414547',
    labelCurrentColor: '#4b286d',
    labelCurrentFontName: 'HNforTELUSSA',
    labelCurrentFontWeight: '700',
    labelDirection: 'column',
    labelFontName: 'HNforTELUSSA',
    labelFontSize: 14,
    labelFontWeight: '400',
    labelGap: 0,
    labelLineHeight: 1.42857142857,
    labelMarginTop: 8,
    labelPaddingLeft: 16,
    labelPaddingRight: 16,
    showStepLabel: false,
    showStepName: true,
    showStepTrackerLabel: true,
    stepLabelColor: '#676e73',
    stepLabelFontName: 'HNforTELUSSA',
    stepLabelFontSize: 12,
    stepLabelFontWeight: '700',
    stepLabelLineHeight: 1.33333333333,
    textStepTrackerLabel: 1
  }
}
export default theme
